import { render, staticRenderFns } from "./AddInstitution.vue?vue&type=template&id=8829c704&scoped=true"
import script from "./AddInstitution.vue?vue&type=script&lang=js"
export * from "./AddInstitution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8829c704",
  null
  
)

export default component.exports